import FactSheetCardImg from "../../Common/FactSheet/factSheetImg.png";

export const BlogCardData = {
  All: [],
  Compliance: [],
  BCM: [],
  Fraud: [],
  GRC: [],
  "Outsourcing Risk": [
    {
      heading:
        "Strengthening Your Outsourcing Risk Management Strategy: Tackling Extended Risk, Exit Management and Integrated Risk",
      navTo: "/insights/blog/content/blog1",
      description: [
        "As businesses deepen their reliance on third-party vendors, particularly in critical sectors like financial services, managing outsourcing risk becomes increasingly complex. Today's digital landscape requires organizations to go beyond traditional third-party risk management, addressing indirect risks and ensuring robust vendor exit management. Recent regulatory frameworks from entities like India’s Reserve Bank of India (RBI) and the EU's Digital Operational Resilience Act (DORA) emphasize the need for strengthened outsourcing risk management and operational resilience.",
      ],
    },
  ],
};
export const FactSheetCardData = {
  All: [
    {
      img: FactSheetCardImg,
      heading:
        "Gain Liability Protection From Data Breach Claims By Implementing Cybersecurity Frameworks",
    },
  ],
  Compliance: [],
  BCM: [],
  Fraud: [],
  GRC: [],
  "Outsourcing Risk": [],
};
export const NewsCardData = {
  All: [],
  Compliance: [],
  BCM: [],
  Fraud: [
    {
      heading: "App Reimbursement in UK",
      navTo:
        "https://www.finextra.com/blogposting/26969/payment-systems-regulators-mandatory-reimbursement-and-the-fraud-impact",
      description: [
        "7 October 2024 is a landmark day for the banking industry and the wider fraud prevention community. The Payment Systems Regulator’s long-anticipated rule changes – to make reimbursement for fraud losses mandatory – have officially gone live.",
        "In what is arguably the most polarising policy initiative in the history of the UK counter-fraud industry; the implementation of the PSR reforms for Authorised Push Payment (APP) fraud marks a step into the regulatory unknown.",
      ],
    },
    {
      heading: "RBI’s New Guidelines on Fraud Risk",
      navTo:
        "https://www.thomsonreuters.com/en-us/posts/investigation-fraud-and-risk/app-fraud-uk/",
      description: [
        "Starting Oct. 7, UK payment service providers must reimburse victims of APP fraud following new regulations by the government's payment regulator",
        "In the United Kingdom, the mandatory reimbursement requirement for authorized push payment (APP) fraud comes into force on Oct. 7. Announced by the Payment Services Regulator (PSR) on June 7, 2023, the new rules will require UK payment service providers to reimburse all in-scope customers who fall victim to APP fraud, save for limited exceptions.",
      ],
    },
  ],
  GRC: [],
  "Outsourcing Risk": [],
};
